
// playground requires you to assign document definition to a variable called dd
export const convertToPDFStockReport = ({ invoiceData, firm,fromDate,toDate }) => {
    var dd = {
        pageOrientation: 'landscape',
        content: [
            { text: 'STOCK BOOK\n\n', style: "gstDataBold" },
			{
				table: {
					widths: ['*'],
					body: [			
						[
							{
								text:[]
								}
                        ],
                        [
							{ text: '', style: "gstDataBold1" },
						],
					]
				}
			},
            {
                table: {

                    body: [
                        [
                            { text: 'S.No', style: "gstHeader", rowSpan: 2 },
                            { text: 'Product Description', style: "gstHeader", rowSpan: 2  },
                            { text: 'Opening', style: "gstHeader", colSpan: 2 , rowSpan: 1 },
                            { text: '', style: "gstHeader", rowSpan: 2  },
                            { text: 'Purchase', style: "gstHeader" , colSpan: 2, rowSpan: 1 },
                            { text: '', style: "gstHeader", rowSpan: 2  },
                            { text: 'Sales', style: "gstHeader" , colSpan: 2 , rowSpan: 1 },
                            { text: '', style: "gstHeader", rowSpan: 2 },
                            { text: 'Closing', style: "gstHeader"  , colSpan: 2, rowSpan: 1 },
                            { text: '', style: "gstHeader", rowSpan: 2  },
                        ],
                        [
                            { text: 'S.No', style: "gstHeader" },
                            { text: 'Name - Description \n', style: "gstHeader1" },
                            { text: 'Quantity', style: "gstHeader"},
                            { text: 'Amount', style: "gstHeader"},
                            { text: 'Quantity', style: "gstHeader"},
                            { text: 'Amount', style: "gstHeader"},
                            { text: 'Quantity', style: "gstHeader"},
                            { text: 'Amount', style: "gstHeader"},
                            { text: 'Quantity', style: "gstHeader"},
                            { text: 'Amount', style: "gstHeader"},
                        ],

                    ]
                }

            },

        ],
        styles: {
            gstHeader: {
                fontSize: 11,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeader1: {
                fontSize: 11,
                bold: true,
                alignment: 'left',
                color: '#160091'
            },
            gstData: {
                fontSize: 9,
                bold: false,
                alignment: 'center'
            },
            gstDataBold: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091',
            },
            gstDataBold1: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091',
                fillColor: '#15155d',
            },
            gstDataAlert: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#B71C1C'
            },
            gstDataInfo: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#0D47A1'
            },
            gstDataSuccess: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#1B5E20'
            },
            gstDataPrimary: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#160091'
            }
        }
    }
    if (firm) {
        dd.content[1].table.body[0][0].text.push({ text: '   Firm : '+ firm, bold: true })
    }
    if (fromDate) {
        dd.content[1].table.body[0][0].text.push({ text: '   From Date : '+ fromDate, bold: true })
    }
    if (toDate) {
        dd.content[1].table.body[0][0].text.push({ text: '   To Date : '+ toDate, bold: true })
    }
    // if (liveAddress) {
    //     dd.content[1].table.body[1][0].text[3].text = liveAddress
    // }
    invoiceData.map((invoice) => {
        let Opening = invoice[3].split('\n');
        let Purchase = invoice[4].split('\n');
        let Sales = invoice[5].split('\n');
        let Closing = invoice[6].split('\n');
            dd.content[2].table.body.push(
                [
                    { text: invoice[0] ,style: "gstData" },
                    { text: invoice[2], style: "gstHeader1" },
                    { text: Opening[0], style: "gstDataInfo" },
                    { text: Opening[1], style: "gstData" },
                    { text: Purchase[0], style: "gstDataPrimary" },
                    { text: Purchase[1], style: "gstData" },
                    { text: Sales[0], style: "gstDataSuccess" },
                    { text: Sales[1], style: "gstData" },
                    { text: Closing[0], style: "gstDataAlert" },
                    { text: Closing[1], style: "gstData" },
    
                ]
            )
    })


    return dd;
}


// WEBPACK FOOTER //
// ./src/utils/pdf-reports/stocks-reports.js